<template>
  <div class="loginWrapper">
    <div class="logoWrapper">
        <img src="../../assets/login/logo.png" alt="">
        <div class="name">杭州第四中学吴山公寓家校绑定系统</div>
    </div>
    <div class="from">
        <div class="title">用户登录</div>
        <div class="formWrapper">
            <div class="input ">
                <div class="img user" />
                <el-input 
                    placeholder="请输入用户名"
                    v-model="user"/>
            </div>
            <div class="input pwd">
                <div class="img pwd" />
                <el-input  
                    placeholder="请输入密码" 
                    v-model="pwd" 
                    autocomplete="new-password"
                    show-password />
            </div>
        </div>
        <el-button class="button" :class="{'nojump':user.length==0||pwd.length==0}" :disabled='user.length>0&&pwd.length>0?false:true' @click="jump()">登录</el-button>
            
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      user:'',
      pwd:'',
    }
  },
  mounted(){
      document.onkeydown = e=> {
          var key = e.event||window.event;
          key&&key.keyCode == 13&&this.$route.name=='Login'?this.jump():''
      }
      
  },
  methods:{
      jump(){
        let data = new FormData();
        data.append("username", this.user);
        data.append("password", this.pwd);
        // data.append("username", "admin");
        // data.append("password", "123456");
          this.$http.post('/attendance/auth/login',data).then(res=>{
                localStorage.setItem('header',res.signature)
              this.$store.state.token = res.signature
              this.$router.push('/main')
          })
           
          
      },
  }
}
</script>


<style lang="scss">
.loginWrapper{
  width: 100%;
  height: 100%;
  background-image: url('../../assets/login/bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  .logoWrapper{
   position: absolute; 
   top: 0;
   left: 0;
   display: flex;
   align-items: center;
   width: 100%;
   background-color: #fff;
   img{
    width: 5vw;
   }
   .name{
        font-size: 1.5rem;
        font-family: BodoniXT;
        font-weight: 400;
   }
  }
  .from{
    padding: 1rem;
    background-color: #fff;
    width: 22.6%;
    height: 35%;
    position: absolute;
    bottom: 15.2%;
    right: 11.8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .title{
        // margin-bottom: 1rem;
        // vertical-align: left;
        text-align: left;
    }
    .formWrapper{
        height: 55.7%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .input{
            position: relative;
            height: 39.7%;   
            .img{
                z-index: 2;
                position: absolute;
                top: 0;
                left: 0;
                display: inline-block;
                width: 1.5rem;
                height: 100%;
                background-repeat: no-repeat;
                background-position: center;
                background-size: 45%;
                margin-left: 0.5rem;
            }
            .user{
                background-image: url('../../assets/login/user.png');
            }
            .pwd{
                background-image: url('../../assets/login/pwd.png');
                
            }
            .el-input {
                height: 100%;
                .el-input__inner {
                    padding-left: 2rem;
                    height: 100%;
                    background-color: rgba($color: #fff, $alpha: 0.1);
                    font-size: 0.63rem;
                }
                .el-input__inner::placeholder {
                    color: #000;
                }
                /* 谷歌 */
                .el-input__inner::-webkit-input-placeholder {
                    color: #000;
                }
                /* 火狐 */
                .el-input__inner:-moz-placeholder {
                    color: #fff;
                }
                /*ie*/
                .el-input__inner:-ms-input-placeholder {
                    color: #fff;
                }
            }
            .el-input__prefix{
                left: 3rem;
            }
        }
      }
      .button{
          height: 22.1%;
          font-size: 1rem;
          width: 100%;
          background-color: #025aaa;
          color: #fff;
      }
      .nojump{
        background-color: #888;
      }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/login.vue